import { TFunction } from "i18next";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model["source"], t: TFunction): string =>
	t(`order_source.${item}`) ?? "";

export default cellProcessing;
